module.exports = __webpack_public_path__ + "img/kagneta-logo.0dd93121.png";